import Button from 'components/Button/src/jsx/Button';
import PropTypes from 'prop-types';
import Heading from './Heading';
import Link from './ui/Link';

export default function ExistingTrialNotification({ apiRoutes, forgetTrialSystem, getLabel, reload }) {
	const onCreateNewClick = () => {
		forgetTrialSystem();
		reload();
	};

	return (
		<div className="trial__existing-notification">
			<Heading title={getLabel('existing_trial_heading')} subtitle={getLabel('existing_trial_subtitle')} />
			<div className="existing-notification__actions">
				{apiRoutes.appLogin && (
					<Link classes={['btn', 'btn--primary']} href={apiRoutes.appLogin} testId="nav-continue">
						{getLabel('nav_btn_login')}
					</Link>
				)}
				<Button onClick={onCreateNewClick} testId="nav-restart">
					{getLabel('nav_btn_create_new')}
				</Button>
			</div>
		</div>
	);
}

ExistingTrialNotification.propTypes = {
	apiRoutes: PropTypes.object.isRequired,
	forgetTrialSystem: PropTypes.func.isRequired,
	getLabel: PropTypes.func.isRequired,
	reload: PropTypes.func.isRequired,
};
